import { IGender } from '@/interfaces';
import { createSlice } from '@reduxjs/toolkit';
import { fetchGenders } from '../thunks';

interface GenderState {
  items: IGender[];
  count: number;
  pages: number;
  page: number;
  limit: number;
  loading: boolean;
}

const initialState: GenderState = {
  items: [],
  count: 0,
  pages: 1,
  page: 1,
  limit: 10,
  loading: false
};

export const genderSlice = createSlice({
  name: 'genders',
  initialState,
  reducers: {
    resetGenders: (state) => {
      state.items = [];
      state.count = 0;
      state.pages = 1;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGenders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGenders.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchGenders.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const { resetGenders } = genderSlice.actions;
export const genderReducer = genderSlice.reducer;
